(function() {
    'use strict';

    angular.module('eDocumentsApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('communication-definition', {
                parent: 'app',
                url: '/communication-definition?page&sort&search',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER'],
                    pageTitle: 'eDocumentsApp.communicationDefinition.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-definition/communication-definitions.html',
                        controller: 'CommunicationDefinitionController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: [
                        '$stateParams',
                        'PaginationUtil',
                        function($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage($stateParams.page),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate($stateParams.sort),
                                ascending: PaginationUtil.parseAscending($stateParams.sort),
                                search: $stateParams.search
                            };
                        }
                    ],
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('communicationDefinition');
                            $translatePartialLoader.addPart('communicationType');
                            $translatePartialLoader.addPart('communicationParameterType');
                            $translatePartialLoader.addPart('communicationParameter');
                            $translatePartialLoader.addPart('communicationWorkflowStep');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('communication-definition-detail', {
                parent: 'communication-definition',
                url: '/communication-definition',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER'],
                    pageTitle: 'eDocumentsApp.communicationDefinition.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-definition/communication-definition-dialog.html',
                        controller: 'CommunicationDefinitionDialogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    id: null
                },
                resolve: {
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('communicationDefinition');
                            return $translate.refresh();
                        }
                    ],
                    entity: [
                        '$stateParams',
                        'CommunicationDefinition',
                        function($stateParams, CommunicationDefinition) {
                            if ($stateParams.id !== null) {
                                return CommunicationDefinition.get({ id: $stateParams.id }).$promise;
                            }
                            return null;
                        }
                    ],
                    readOnly: function() {
                        return true;
                    },
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'communication-definition',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })
            .state('communication-definition-detail.edit', {
                parent: 'communication-definition-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-definition/communication-definition-dialog.html',
                        controller: 'CommunicationDefinitionDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [
                        '$stateParams',
                        'CommunicationDefinition',
                        function($stateParams, CommunicationDefinition) {
                            return CommunicationDefinition.get({ id: $stateParams.id }).$promise;
                        }
                    ],
                    readOnly: function() {
                        return false;
                    },
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'communication-definition',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })
            .state('communication-definition.new', {
                parent: 'communication-definition',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-definition/communication-definition-dialog.html',
                        controller: 'CommunicationDefinitionDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [
                        'CommunicationDefinition',
                        function(CommunicationDefinition) {
                            return new CommunicationDefinition();
                        }
                    ],
                    readOnly: function() {
                        return false;
                    },
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'communication-definition',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })
            .state('communication-definition.edit', {
                parent: 'communication-definition',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-definition/communication-definition-dialog.html',
                        controller: 'CommunicationDefinitionDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [
                        '$stateParams',
                        'CommunicationDefinition',
                        function($stateParams, CommunicationDefinition) {
                            return CommunicationDefinition.get({ id: $stateParams.id }).$promise;
                        }
                    ],
                    readOnly: function() {
                        return false;
                    },
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'communication-definition',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })
            .state('communication-definition.delete', {
                parent: 'communication-definition',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER']
                },
                onEnter: [
                    '$stateParams',
                    '$state',
                    '$uibModal',
                    function($stateParams, $state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl: 'app/entities/communication-definition/communication-definition-delete-dialog.html',
                                controller: 'CommunicationDefinitionDeleteController',
                                controllerAs: 'vm',
                                size: 'md',
                                resolve: {
                                    entity: [
                                        'CommunicationDefinition',
                                        function(CommunicationDefinition) {
                                            return CommunicationDefinition.get({ id: $stateParams.id }).$promise;
                                        }
                                    ]
                                }
                            })
                            .result.then(
                            function() {
                                $state.go('communication-definition', null, { reload: 'communication-definition' });
                            },
                            function() {
                                $state.go('^');
                            }
                        );
                    }
                ]
            });
    }
})();
